export default "__VITE_ASSET__0e23ce0f__"